import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
import { useState } from 'react';
import { Box, TextField, Button, InputAdornment } from '@mui/material';
import SearchIcon from '@mui/icons-material/Search';
import { useNavigate } from 'react-router-dom';
import { navigateOrAssign } from '../../../utils/internalPath';
import { sectionBackgrounds, resolveGradient } from '../../../theme';
/**
 * SearchBlock – search input; optional actionUrl for form submit or API.
 */
const SearchBlock = ({ label, gradient, placeholder = 'Search…', buttonLabel = 'Search', actionUrl, paddingTop, paddingBottom, marginTop, marginBottom, maxWidth, componentAlignment = 'left', }) => {
    const navigate = useNavigate();
    const [query, setQuery] = useState('');
    const background = gradient
        ? resolveGradient(gradient, sectionBackgrounds.hero)
        : 'transparent';
    const handleSubmit = (e) => {
        e.preventDefault();
        if (actionUrl) {
            const url = actionUrl.includes('?') ? `${actionUrl}&q=${encodeURIComponent(query)}` : `${actionUrl}?q=${encodeURIComponent(query)}`;
            navigateOrAssign(navigate, url);
        }
    };
    return (_jsx(Box, { component: "section", sx: {
            background,
            paddingTop: paddingTop || 3,
            paddingBottom: paddingBottom || 3,
            marginTop: marginTop || 0,
            marginBottom: marginBottom || 0,
            textAlign: componentAlignment,
        }, children: _jsxs(Box, { sx: { maxWidth: maxWidth || 640, mx: 'auto', px: 2 }, children: [label && (_jsx(Box, { component: "span", sx: {
                        display: 'block',
                        mb: 2,
                        fontSize: '0.75rem',
                        textTransform: 'uppercase',
                        letterSpacing: 1,
                        color: 'text.secondary',
                    }, children: label })), _jsxs(Box, { component: "form", onSubmit: handleSubmit, sx: { display: 'flex', gap: 1, flexWrap: 'wrap' }, children: [_jsx(TextField, { fullWidth: true, variant: "outlined", placeholder: placeholder, value: query, onChange: (e) => setQuery(e.target.value), InputProps: {
                                startAdornment: (_jsx(InputAdornment, { position: "start", children: _jsx(SearchIcon, { color: "action" }) })),
                            }, sx: { flex: '1 1 280px' } }), _jsx(Button, { type: "submit", variant: "contained", color: "primary", size: "large", sx: { minWidth: 120, fontWeight: 600 }, children: buttonLabel })] })] }) }));
};
export default SearchBlock;
